(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["noir-purchase-notes"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__noirPurchaseInit) return;
    window.__noirPurchaseInit = true;

    function label() {
      var el = document.querySelector('[data-noir-label]');
      return (el && el.getAttribute('data-noir-label')) || 'Add to Bag';
    }

    function relabel() {
      var text = label();
      document.querySelectorAll('.add-to-cart-button, .sticky-add-to-cart__button').forEach(function (btn) {
        var walker = document.createTreeWalker(btn, NodeFilter.SHOW_TEXT);
        var node;
        while ((node = walker.nextNode())) {
          if (/add to cart/i.test(node.nodeValue)) {
            node.nodeValue = node.nodeValue.replace(/add to cart/gi, text);
          }
        }
      });
    }

    function start() {
      relabel();
      new MutationObserver(relabel).observe(document.body, { childList: true, subtree: true, characterData: true });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start);
    } else {
      start();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
